import React from "react";
import "./TextCCC.css";

const TextCCC = () => {
  return (
    <div className="text-section-c">
      <div className="max-width">
        <h1>The Brilliance of Diamonds</h1>
        <h4>Understanding Diamonds: <span className="sec-mg">The 4 Cs</span> </h4>
        <h4 className="sec-mg">Cut</h4>
        <h4>
          The cut of a diamond determines how well it reflects light, creating
          its signature sparkle. A well-cut diamond will appear brilliant and
          radiant, while a poorly cut one may look dull.
        </h4>
        <h4 className="sec-mg">Clarity </h4>
        <h4>
          Clarity refers to the natural imperfections (inclusions) within a
          diamond. The fewer the inclusions, the higher the clarity, making the
          diamond appear more flawless and valuable.
        </h4>
        <h4 className="sec-mg">Colour</h4>
        <h4>
          Diamonds range from completely colourless to lightly tinted. The less
          colour a diamond has, the rarer and more desirable it becomes, with
          colourless diamonds being the most valuable.
        </h4>
        <h4 className="sec-mg">Carat</h4>
        <h4>
          Carat refers to the weight of a diamond, not necessarily its size.
          Larger diamonds typically have a higher carat weight, but a well-cut
          smaller diamond can be just as striking.
        </h4>
      </div>
    </div>
  );
};

export default TextCCC;
